function t(e) {
  const r = e.replace(/\./g, "").replace(",", ".").replace("R$", "").trim();
  return Number.parseFloat(r);
}
export { t as default };